import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/System/Log/SuccessBox';
import LogTable from 'components/Web_User_Interface/1080p_Series/System/Log/logTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  LogTable,
  BreadCrumbs,
  SEOHelmet,
  React
};